/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { OAuthFlow } from './OAuthFlow';

/**
 * Models a password OAuth flow.
 * 
 * @author eric.wittmann@gmail.com
 * @class
 * @extends OAuthFlow
 */
export abstract class PasswordOAuthFlow extends OAuthFlow {
    constructor() {
        super();
    }
}
PasswordOAuthFlow["__class"] = "io.apicurio.datamodels.core.models.common.PasswordOAuthFlow";
PasswordOAuthFlow["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




